import PropTypes from "prop-types";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { EDS } from "../theme";

const MAP = {
  search: SearchOutlinedIcon,
  cart: ShoppingBagOutlinedIcon,
  menu: MenuOutlinedIcon,
  back: ArrowBackOutlinedIcon,
  add: AddOutlinedIcon,
  remove: RemoveOutlinedIcon,
};

/**
 * Outlined icons with explicit color — avoids MUI theme primary bleeding through.
 */
export default function EdsIcon({ name, size = 20, color, sx }) {
  const Component = MAP[name];
  if (!Component) return null;
  return (
    <Component
      sx={{
        fontSize: size,
        color: color || "currentColor",
        display: "block",
        ...sx,
      }}
    />
  );
}

EdsIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(MAP)).isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  sx: PropTypes.shape({}),
};

EdsIcon.defaultProps = {
  size: 20,
  color: "",
  sx: {},
};

export { EDS };
